import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import { IR23ReportMetadata } from '@/interfaces/report';
import { AsphaltDesignMetric, IAsphaltDesignImperial } from '@/modules/design/interfaces/newAsphalt';

import { exampleAsphaltDesignR23Report } from '@/lib/data/exampleR23Reports';
import { UnitSystem } from '@/interfaces/units';
import { asphaltMetricToImperial, newAsphaltDesignImperialToMetric } from '@/modules/design/lib/unitConversion/asphalt';
import {
  getAcOverlayDesignFromR23Report,
  getAsphaltDesignFromR23Report,
  getConcreteDesignFromR23Report,
  getPorousDesignFromR23Report,
} from '@/modules/design/lib/r23ToSuiteTransformers';
import { store } from '@/store/store';
import { ConcreteDesignMetric, IConcreteDesignImperial } from '@/modules/design/interfaces/newConcrete';
import { concreteImperialToMetric, concreteMetricToImperial } from '@/modules/design/lib/unitConversion/concrete';
import { IPorousDesignImperial, PorousDesignMetric } from '@/modules/design/interfaces/porous';
import { porousImperialToMetric, porousMetricToImperial } from '@/modules/design/lib/unitConversion/porous';
import { IAcOverlayDesignImperial, IAcOverlayDesignMetric } from '@/modules/design/interfaces/acOverlay';
import { acOverlayImperialToMetric, acOverlayMetricToImperial } from '@/modules/design/lib/unitConversion/acOverlay';
import { $http } from '@/main';
import { AxiosResponse } from 'axios';
import { IPxError, processReason } from '@/lib/util/errors';
import { IDesignBaseScenario } from '@/lib/types/IBaseScenario';
// import {exampleNewConcreteDesignR23Report} from "@/lib/data/exampleR23Reports";
//
//
const testProjectMetadata: IR23ReportMetadata = {
  ownerEmail: 'ben@trisightengineering.com',
  ownerFirstName: 'ben',
  ownerLastName: 'ciavola',
  r23ReportId: 1,
  reportTitle: 'King Street',
  created: new Date(2019, 5, 20).toISOString(),
  updated: new Date(Date.now()).toISOString(),
  visible: true,
  conversion_started: false,
  conversion_complete: false,
  conversion_done_design: null,
  conversion_done_lcca: null,
  conversion_done_analyze: null,
  conversion_done_other: null,
};


// const defaultAsphaltDesignImperial: IAsphaltDesignImperial = createNewAsphaltScenario()
const defaultAsphaltDesignImperial: IAsphaltDesignImperial = getAsphaltDesignFromR23Report(testProjectMetadata, exampleAsphaltDesignR23Report, 0);
const defaultConcreteDesignImperial: IConcreteDesignImperial = getConcreteDesignFromR23Report(testProjectMetadata, exampleAsphaltDesignR23Report, 0);
const defaultPorousDesignImperial: IPorousDesignImperial = getPorousDesignFromR23Report(testProjectMetadata, exampleAsphaltDesignR23Report, 0);
const defaultAcOverlayDesignImperial: IAcOverlayDesignImperial = getAcOverlayDesignFromR23Report(testProjectMetadata, exampleAsphaltDesignR23Report, 0);

@Module({
  name: 'design',
  // dynamic: true,
  // store: store,
  namespaced: true,
})
export default class DesignStore extends VuexModule {
  store = store;

  /*
  A central location for http httpErrors to go
   */
  httpErrors: IPxError[] = [];

  @Mutation
  pushHttpErrors(reason: { response: AxiosResponse }) {
    this.httpErrors = processReason(reason);
  }

  @Mutation
  pushError(error: IPxError) {
    this.httpErrors.push(error);
  }

  @Mutation
  clearErrors() {
    this.httpErrors = [];
  }


  // @Action
  // setCurrentProject(metadata: IR23ReportMetadata, report: IR23Report) {
  //   console.log("Setting Current Project with Action in Designstore")
  //   this.currentAsphaltImperial = getAsphaltDesignFromR23Report( metadata, report );
  // }


  /*
  Unit system
   */

  displayUnits: UnitSystem = UnitSystem.Imperial;

  @Mutation
  setDisplayUnits(targetUnitSystem: UnitSystem) {
    console.log('Changing units to', targetUnitSystem);
    this.displayUnits = targetUnitSystem;
    if (this.currentScenarioImperial) {
      this.currentScenarioImperial.displayUnits = this.displayUnits;
    }
  }

  /*
  Shared functionality and dispatchers
   */

  // getProjectMetadata: IProjectMetadata | null = null;

  currentScenarioImperial: IAsphaltDesignImperial
    | IConcreteDesignImperial
    | IPorousDesignImperial
    | IAcOverlayDesignImperial
    | null
    = null;

  //
  // @Action({ rawError: true })
  // async saveCurrentScenario() {
  //   if (this.currentScenarioImperial && this.currentScenarioImperial.id) {
  //     this.currentScenarioImperial.displayUnits = this.displayUnits;
  //
  //     console.log('Saving', this.currentScenarioImperial);
  //     switch (this.currentScenarioImperial.designScenarioType) {
  //       case DesignScenarioType.asphalt:
  //         return this.saveCurrentAsphaltScenario().catch((reason) => this.pushHttpErrors(reason));
  //       case DesignScenarioType.concrete:
  //         return this.saveCurrentConcreteScenario().catch((reason) => this.pushHttpErrors(reason));
  //       case DesignScenarioType.porous:
  //         return this.saveCurrentPorousScenario().catch((reason) => this.pushHttpErrors(reason));
  //       case DesignScenarioType.acOverlay:
  //         return this.saveCurrentAcOverlayScenario().catch((reason) => this.pushHttpErrors(reason));
  //       default:
  //           return false;
  //     }
  //   } else if (this.currentScenarioImperial) {
  //     console.log('Saving new', this.currentScenarioImperial);
  //     switch (this.currentScenarioImperial.designScenarioType) {
  //       case DesignScenarioType.asphalt:
  //         return this.saveNewAsphaltScenario(this.currentScenarioImperial).catch((reason) => this.pushHttpErrors(reason));
  //       case DesignScenarioType.concrete:
  //         return this.saveNewConcreteScenario(this.currentScenarioImperial).catch((reason) => this.pushHttpErrors(reason));
  //       case DesignScenarioType.porous:
  //         return this.saveNewPorousScenario(this.currentScenarioImperial).catch((reason) => this.pushHttpErrors(reason));
  //       case DesignScenarioType.acOverlay:
  //         return this.saveNewAcOverlayScenario(this.currentScenarioImperial).catch((reason) => this.pushHttpErrors(reason));
  //       default:
  //         return false;
  //     }
  //   }
  //  
  //   return false;
  // }

  @Action({ rawError: true })
  deleteScenario(data: { scenario: IDesignBaseScenario, urlKey: string }) {
    /*
    Used by ScenarioContainer to handle deletion of scenarios.
     */

    const deleteUrl = `/project/design/${data.urlKey}/${data.scenario.id}`;

    return $http.delete(deleteUrl).catch((reason) => this.pushHttpErrors(reason));

    // return $http.delete(url + scenario.id)
    // switch (scenario.designScenarioType) {
    //   case DesignScenarioType.asphalt:
    //     return this.saveCurrentAsphaltScenario();
    //   case DesignScenarioType.concrete:
    //     return this.saveCurrentConcreteScenario();
    //   case DesignScenarioType.porous:
    //     return this.saveCurrentPorousScenario();
    //   case DesignScenarioType.acOverlay:
    //     return this.saveCurrentAcOverlayScenario();
    // }
  }

  /*
  Asphalt Models
   */

  currentAsphaltImperial: IAsphaltDesignImperial = defaultAsphaltDesignImperial;

  get currentAsphaltMetric(): AsphaltDesignMetric {
    return newAsphaltDesignImperialToMetric(this.currentAsphaltImperial);
  }

  get currentAsphalt(): IAsphaltDesignImperial | AsphaltDesignMetric {
    if (this.displayUnits === UnitSystem.Imperial) {
      return this.currentAsphaltImperial;
    }
    return this.currentAsphaltMetric;
  }

  @Mutation
  setCurrentAsphaltScenario(asphaltScenario: IAsphaltDesignImperial | AsphaltDesignMetric) {
    this.displayUnits = asphaltScenario.displayUnits;
    // console.log('Setting asphalt, from:', asphaltScenario);
    if (asphaltScenario.unitSystem === UnitSystem.Imperial) {
      // console.log('Setting IMPERIAL', asphaltScenario.displayUnits);
      this.currentAsphaltImperial = asphaltScenario;
      console.log(this.currentAsphaltImperial);
    } else if (asphaltScenario.unitSystem === UnitSystem.Metric) {
      // console.log('SettingMETRIC', asphaltScenario.displayUnits);
      // @ts-ignore
      this.currentAsphaltImperial = asphaltMetricToImperial(asphaltScenario);
    }
    this.currentScenarioImperial = this.currentAsphaltImperial;
  }

  @Action({ rawError: true })
  saveNewAsphaltScenario(scenario: IAsphaltDesignImperial) {
    scenario.displayUnits = this.displayUnits;
    // console.log("Saving asphalt design:", scenario.name);
    return $http.post('project/design/asphalt/new', scenario).then((response) => response.data).catch((reason) => {
      this.pushHttpErrors(reason);
      return null;
    });
  }

  @Action({ rawError: true })
  loadCurrentAsphaltScenario(id: number) {
    return $http.get(`project/design/asphalt/${id}`).then((response) => {
      this.setCurrentAsphaltScenario(response.data);
      return response.data;
    }).catch((reason) => this.pushHttpErrors(reason));
  }

  @Action({ rawError: true })
  saveCurrentAsphaltScenario() {
    // Set the display units to use for this scenario when it's loaded next time
    // console.log(this.displayUnits);
    this.currentAsphaltImperial.displayUnits = this.displayUnits;


    // console.log("saving asphalt to db", this.displayUnits, this.currentAsphaltImperial.id, this.currentAsphaltImperial.displayUnits, this.currentAsphaltImperial);

    return $http.put(`project/design/asphalt/${this.currentAsphaltImperial.id}`, this.currentAsphaltImperial).then(
      (response) => {
        this.setCurrentAsphaltScenario(response.data);
      },
    );
  }

  /*
  Concrete Models
   */

  currentConcreteImperial: IConcreteDesignImperial = defaultConcreteDesignImperial;

  get currentConcreteMetric(): ConcreteDesignMetric {
    return concreteImperialToMetric(this.currentConcreteImperial);
  }

  get currentConcrete(): IConcreteDesignImperial | ConcreteDesignMetric {
    let s: IConcreteDesignImperial | ConcreteDesignMetric;
    if (this.displayUnits === UnitSystem.Imperial) {
      s = this.currentConcreteImperial;
    } else {
      s = this.currentConcreteMetric;
    }
    return s;
  }

  @Mutation
  setCurrentConcreteScenario(ds: IConcreteDesignImperial | ConcreteDesignMetric) {
    // console.log("Sync concrete", ds.displayUnits);
    this.displayUnits = ds.displayUnits;
    if (ds.unitSystem === UnitSystem.Imperial) {
      this.currentConcreteImperial = ds;
    } else if (ds.unitSystem === UnitSystem.Metric) {
      this.currentConcreteImperial = concreteMetricToImperial(ds);
    }
    this.currentScenarioImperial = this.currentConcreteImperial;
  }


  @Action({ rawError: true })
  saveNewConcreteScenario(scenario: IConcreteDesignImperial) {
    scenario.displayUnits = this.displayUnits;
    // console.log("Saving concrete design:", scenario.name, scenario.displayUnits);
    return $http.post('project/design/concrete/new', scenario).then((response) => response.data).catch((reason) => {
      console.log(reason);
      return null;
    }).catch((reason) => this.pushHttpErrors(reason));
  }

  @Action({ rawError: true })
  loadCurrentConcreteScenario(id: number) {
    return $http.get(`project/design/concrete/${id}`).then((response) => {
      this.setCurrentConcreteScenario(response.data);
      return response.data;
    });
  }

  @Action({ rawError: true })
  saveCurrentConcreteScenario() {
    this.currentConcreteImperial.displayUnits = this.displayUnits;
    // console.log("saving concrete to db", this.currentConcreteImperial.id, this.currentConcreteImperial.displayUnits, this.currentConcreteImperial);
    return $http.put(`project/design/concrete/${this.currentConcreteImperial.id}`, this.currentConcreteImperial).then(
      (response) => {
        this.setCurrentConcreteScenario(response.data);
      },
    );
  }

  /*
  Porous Models
   */
  currentPorousImperial: IPorousDesignImperial = defaultPorousDesignImperial;

  get currentPorousMetric(): PorousDesignMetric {
    return porousImperialToMetric(this.currentPorousImperial);
  }

  get currentPorous(): IPorousDesignImperial | PorousDesignMetric {
    let s: IPorousDesignImperial | PorousDesignMetric;
    if (this.displayUnits === UnitSystem.Imperial) {
      s = this.currentPorousImperial;
    } else {
      s = this.currentPorousMetric;
    }
    return s;
  }

  @Mutation
  setCurrentPorousScenario(ds: IPorousDesignImperial | PorousDesignMetric) {
    // console.log("Sync porous", ds.displayUnits);
    this.displayUnits = ds.displayUnits;
    if (ds.unitSystem === UnitSystem.Imperial) {
      this.currentPorousImperial = ds;
    } else if (ds.unitSystem === UnitSystem.Metric) {
      this.currentPorousImperial = porousMetricToImperial(ds);
    }
    this.currentScenarioImperial = this.currentPorousImperial;
  }

  @Action({ rawError: true })
  saveNewPorousScenario(scenario: IPorousDesignImperial) {
    scenario.displayUnits = this.displayUnits;
    // console.log("Saving porous design:", scenario.name);
    return $http.post('project/design/porous/new', scenario).then((response) => response.data).catch((reason) => {
      console.log(reason);
      this.pushHttpErrors(reason);
      return null;
    });
  }

  @Action({ rawError: true })
  loadCurrentPorousScenario(id: number) {
    return $http.get(`project/design/porous/${id}`).then((response) => {
      this.setCurrentPorousScenario(response.data);
      return response.data;
    }).catch((reason) => this.pushHttpErrors(reason));
  }

  @Action({ rawError: true })
  saveCurrentPorousScenario() {
    this.currentPorousImperial.displayUnits = this.displayUnits;
    // console.log("saving porous to db", this.currentPorousImperial.id, this.currentPorousImperial.displayUnits, this.currentPorousImperial);
    return $http.put(`project/design/porous/${this.currentPorousImperial.id}`, this.currentPorousImperial).then(
      (response) => {
        this.setCurrentPorousScenario(response.data);
      },
    );
  }

  /*
  Ac Overlay Models
   */

  get currentAcOverlay(): IAcOverlayDesignImperial | IAcOverlayDesignMetric {
    let s: IAcOverlayDesignImperial | IAcOverlayDesignMetric;
    if (this.displayUnits === UnitSystem.Imperial) {
      s = this.currentAcOverlayImperial;
    } else {
      s = this.currentAcOverlayMetric;
    }
    return s;
  }

  currentAcOverlayImperial: IAcOverlayDesignImperial = defaultAcOverlayDesignImperial;

  get currentAcOverlayMetric(): IAcOverlayDesignMetric {
    return acOverlayImperialToMetric(this.currentAcOverlayImperial);
  }

  @Mutation
  setCurrentAcOverlayScenario(ds: IAcOverlayDesignImperial | IAcOverlayDesignMetric) {
    // console.log("Sync Ac Overlay", ds.displayUnits);
    this.displayUnits = ds.displayUnits;
    if (ds.unitSystem === UnitSystem.Imperial) {
      this.currentAcOverlayImperial = ds;
    } else if (ds.unitSystem === UnitSystem.Metric) {
      this.currentAcOverlayImperial = acOverlayMetricToImperial(ds);
    }
    this.currentScenarioImperial = this.currentAcOverlayImperial;
  }

  @Action({ rawError: true })
  saveNewAcOverlayScenario(scenario: IAcOverlayDesignImperial) {
    scenario.displayUnits = this.displayUnits;
    // console.log("Saving acOverlay design:", scenario.name)  ;
    return $http.post('project/design/ac-overlay/new', scenario).then((response) => response.data).catch((reason) => {
      this.pushHttpErrors(reason);
      return null;
    });
  }

  @Action({ rawError: true })
  loadCurrentAcOverlayScenario(id: number) {
    return $http.get(`project/design/ac-overlay/${id}`).then((response) => {
      this.setCurrentAcOverlayScenario(response.data);
      return response.data;
    });
  }

  @Action({ rawError: true })
  saveCurrentAcOverlayScenario() {
    this.currentAcOverlayImperial.displayUnits = this.displayUnits;
    // console.log("saving acOverlay to db", this.currentAcOverlayImperial.id, this.currentAcOverlayImperial.displayUnits, this.currentAcOverlayImperial);
    return $http.put(`project/design/ac-overlay/${this.currentAcOverlayImperial.id}`, this.currentAcOverlayImperial).then(
      (response) => {
        this.setCurrentAcOverlayScenario(response.data);
      },
    );
  }

  currentRehabScenario = null;

  currentLccaScenario = null;

  currentAgencyScenario = null;

  currentAnalysisScenario = null;
}
